<div class="catalog" *ngIf="!isLoading">
  <div class="catalog__header">
    <h2 class="catalog__header-text">{{ getHeaderText() }}</h2>
  </div>
  <div class="catalog__content">
    <app-catalog-card
    *ngFor="let card of cards  "
    [cardData]="card"
    (favoriteChange)="toggleFavorite($event)"
    ></app-catalog-card>
    <div *ngIf="!totalPagesCount.length" class="catalog-empty-result">
      <div class="catalog-empty-result__title">
        {{noResultsTitle}}
      </div>
      <div class="catalog-empty-result__text" [innerHTML]="noResultsText"></div>
      <button class="catalog-empty-result__clear-btn link" (click)="clearAll()">
        <div>{{clearAllText}}</div>
      </button>
      <div class="catalog-empty-result__image">
        <img [src]="noResultsImage" width="202" height="283" />
      </div>
    </div>
  </div>
  <div class="catalog__footer">
      <app-paginator [totalResults]="totalSearchResultsCount" [currentPage]="currentPage" [pageSize]="pageSize" (pageChanged)="goToPage($event)"  [paginatorContainerClass]="paginatorContainerCssClass"  [activeLiClass]="'active'"
    [activeLinkClass]="'active'" [liClass]="'pagination__link'" [linkClass]="'pagination__link_a'" [disabledLiClass]="''" [rangeSize]="rangeSize"></app-paginator>
  </div>
</div>
  
   
 
<div class="catalog" *ngIf="isLoading">
  <div class="catalog__content">
    <div class="catalog__header">
      <h2 ></h2>
      <app-skeleton class="catalog__header-text" [type]="'text'" [symbolsCount]="14"/>
    </div>
    <div class="catalog__content">
      <app-skeleton *ngFor="let _ of [].constructor(pageSize > 0 ? pageSize : 3)" class="catalog-item-skeleton" [height]="280" />
    </div>
    <div class="catalog__footer">
        <app-paginator [totalResults]="totalSearchResultsCount" [currentPage]="currentPage" [pageSize]="pageSize" (pageChanged)="goToPage($event)"  [paginatorContainerClass]="paginatorContainerCssClass"  [activeLiClass]="'active'"
          [activeLinkClass]="'active'" [liClass]="'pagination__link'" [linkClass]="'pagination__link_a'" [disabledLiClass]="''" [rangeSize]="rangeSize"></app-paginator>
    </div>
  </div>
</div>